import { render, staticRenderFns } from "./SuspiciousActivityList.vue?vue&type=template&id=0963b9a9&scoped=true&"
import script from "./SuspiciousActivityList.vue?vue&type=script&lang=js&"
export * from "./SuspiciousActivityList.vue?vue&type=script&lang=js&"
import style0 from "./SuspiciousActivityList.vue?vue&type=style&index=0&id=0963b9a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0963b9a9",
  null
  
)

export default component.exports